import { render, staticRenderFns } from "./template.vue?vue&type=template&id=b90c5c1e&scoped=true&"
import script from "./template.vue?vue&type=script&lang=js&"
export * from "./template.vue?vue&type=script&lang=js&"
import style0 from "./template.vue?vue&type=style&index=0&id=b90c5c1e&lang=scss&scoped=true&"
import style1 from "./template.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b90c5c1e",
  null
  
)

export default component.exports